module.exports = __webpack_public_path__ + "img/1481768180.24234f2e.jpg";